import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.css'],
})
export class SearchPageComponent implements OnInit {
  searchGroup: FormGroup;
  private searchApi = environment.url + environment.incubateeList;
  /**
   * Constructor for the SearchPageComponent.
   * It initializes the search form with one required field, incubateeName.
   * It also subscribes to the route query parameters and calls the search method
   * if the _name query parameter is present.
   * @param router The Angular router service.
   * @param fb The Angular form builder service.
   * @param makeapi The API service to make API calls.
   * @param getdata The value service to manage application state.
   * @param route The Angular route service to access route query parameters.
   */
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private route: ActivatedRoute
  ) {
    /**
     * The search form with one required field, incubateeName.
     */
    this.searchGroup = this.fb.group({
      incubateeName: ['', [Validators.required]],
    });
  }

  /**
   * Lifecycle hook that is called when the component is initialized.
   * It sets the visible source flag to true and watches for changes in the route query parameters.
   * If the _name query parameter is present, it calls the search method with the _name value.
   */
  ngOnInit(): void {
    // Set the visible source flag to true
    this.getdata.isVisibleSource.next(true);

    // Watch for changes in the route query parameters
    this.route.queryParams
      .pipe(
        // Filter the query parameters to only consider those with a `_name` key
        filter((params) => params._name)
      )
      .subscribe((params) => {
        // Set the visible source flag to true again
        this.getdata.isVisibleSource.next(true);

        // Call the search method with the `_name` value
        this.search(params._name);
      });
  }
  searchList = [];
  display = true;
  /**
   * Updates the search form with the search value and calls the searchValue method.
   * @param name - The search value to search for.
   */
  search(name) {
    let getform = this.searchGroup.value;
    // Update the form with the search value
    getform.incubateeName = name;
    this.searchGroup.patchValue(getform);
    // Call the searchValue method
    this.searchValue(name);
  }
  /**
   * Fetches the list of incubatees from the API based on the search value.
   * @param name - The search value to search for.
   */
  searchValue(name: string) {
    if (name.length != 0) {
      // Prepare the request parameters
      let req = {
        searchString: name,
        pageNumber: 1,
        listSize: 10,
      };

      // Show the loader while fetching data
      this.getdata.amizhthLoader('show');

      // Clear the search results
      this.searchList = [];

      // Call the API to fetch the list of incubatees
      this.makeapi
        .method(this.searchApi, req, 'postunauth')
        .subscribe((data) => {
          // Hide the loader after receiving data
          this.getdata.amizhthLoader('hide');

          // Check if the response contains any data
          if (data.count != 0) {
            // If there is data, update the component data
            this.display = false;
            this.searchList = data.responsemodelList;
          } else {
            // If there is no data, show the "No Data" message
            this.display = true;
          }
        });
    } else {
      // Clear the search results and navigate to the search page if the search value is empty
      this.searchList = [];
      this.searchGroup.reset();
      this.display = true;
      this.router.navigate(['search']);
    }
  }
  /**
   * Clears the search results and navigates to the home page.
   */
  clearSearch() {
    // Clear the search results
    this.searchList = [];
    // Reset the search form
    this.searchGroup.reset();
    // Navigate to the home page
    this.router.navigate(['home']);
  }
}
